import { render, staticRenderFns } from "./OAuthLogout.vue?vue&type=template&id=35c39fbe&scoped=true&"
import script from "./OAuthLogout.vue?vue&type=script&lang=js&"
export * from "./OAuthLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c39fbe",
  null
  
)

export default component.exports